import { Button } from "@/components/ui/button";
import { Link } from "@/components/link";
import { StatusNote } from "@/components/status-note";

// Was src/app/not-found.tsx, now the router's notFoundComponent.
export function NotFound() {
  return (
    <StatusNote>
      <div className="flex flex-col gap-3">
        <h1 className="text-lg font-semibold tracking-tight">Page not found</h1>
        <p className="text-muted-foreground text-sm leading-6">
          That page doesn&apos;t exist or has moved.
        </p>
        <div className="mt-2 flex items-center justify-center gap-2">
          <Button nativeButton={false} render={<Link href="/" />}>
            Go to dashboard
          </Button>
        </div>
      </div>
    </StatusNote>
  );
}
